import React from "react";
import { clsx } from "clsx";
import { X } from "lucide-react";

export interface TagProps extends React.HTMLAttributes<HTMLSpanElement> {
    onRemove?: () => void;
}

export const Tag: React.FC<TagProps> = ({ children, onRemove, className, ...props }) => (
    <span
        className={clsx(
            "inline-flex items-center gap-1 rounded-mz-md bg-neutral-dark/5 px-2 py-0.5 text-xs font-medium text-neutral-dark dark:bg-white/10 dark:text-white",
            className,
        )}
        {...props}
    >
        {children}
        {onRemove ? (
            <button type="button" onClick={onRemove} className="rounded p-0.5 hover:bg-black/10 dark:hover:bg-white/20" aria-label="Remove">
                <X size={12} />
            </button>
        ) : null}
    </span>
);
